var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "card__content" }, [
      _c("div", { staticClass: "table-responsive" }, [
        _c("table", [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(_vm.logs, function(log, index) {
                return _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: log.respuestas.length > 0,
                        expression: "log.respuestas.length > 0"
                      }
                    ],
                    key: index
                  },
                  [
                    _c("td", [
                      _vm._v(
                        _vm._s(log.numero_documento) +
                          " (" +
                          _vm._s(log.tipo_comprobante.descripcion) +
                          ")"
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("table", [
                        _vm._m(2, true),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(log.respuestas, function(respuesta) {
                            return _c("tr", { key: respuesta.id_comprobante }, [
                              _c("td", [
                                _vm._v(
                                  _vm._s(respuesta.tipo_ambiente.descripcion)
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(respuesta.fecha))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(respuesta.respuesta))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(respuesta.tipo))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(respuesta.informacion_adicional))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(respuesta.identificador))
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(respuesta.estado))])
                            ])
                          }),
                          0
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "a",
                        {
                          staticClass: "btn-secondary btn--text",
                          attrs: {
                            target: "_blank",
                            href:
                              _vm.url +
                              "/comprobantes/" +
                              log.id_comprobante +
                              "/ride"
                          }
                        },
                        [_c("i", { staticClass: "fa fa-eye" })]
                      ),
                      _vm._v(" "),
                      log.id_estado_comprobante === "AUT"
                        ? _c(
                            "a",
                            {
                              staticClass: "btn-success btn--text",
                              attrs: {
                                target: "_blank",
                                href:
                                  _vm.url +
                                  "/comprobantes/" +
                                  log.id_comprobante +
                                  "/xml"
                              }
                            },
                            [_c("i", { staticClass: "fa fa-file-excel-o" })]
                          )
                        : _vm._e()
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              _vm.logs.length === 0 ? _c("tr", [_vm._m(3)]) : _vm._e()
            ],
            2
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Logs")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("# Doc.")]),
        _vm._v(" "),
        _c("th", [_vm._v("Detalles")]),
        _vm._v(" "),
        _c("th", [_vm._v("Acciones")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("T. Ambiente")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha")]),
        _vm._v(" "),
        _c("th", [_vm._v("Respuesta")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tipo")]),
        _vm._v(" "),
        _c("th", [_vm._v("Información Adic.")]),
        _vm._v(" "),
        _c("th", [_vm._v("Identificador")]),
        _vm._v(" "),
        _c("th", [_vm._v("Estado")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "3" } }, [
      _c("strong", [_vm._v("No se ha encontrado logs.")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-88456db6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88456db6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/reportes/TablaLogsReporteVentas.vue
// module id = 496
// module chunks = 0